export default {"src":"https://fishbrain.com/_next/static/media/smallmouthBass.bd4283f8.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};